module.exports = __webpack_public_path__ + "static/img/volver_rojo.c8635a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/UI/volver_rojo.svg
// module id = cNkN
// module chunks = 0